import { CompositeKeys, HotKey } from '@viewer/data';

export namespace KeyInteractionUtils {
  export function defineCompositeKeys(
    event: MouseEvent | KeyboardEvent
  ): CompositeKeys[] {
    const keys: CompositeKeys[] = [];

    if (event.ctrlKey && !checkIsExactKey(event, HotKey.CtrlLeft)) {
      keys.push(CompositeKeys.Ctrl);
    }
    if (event.shiftKey) {
      keys.push(CompositeKeys.Shift);
    }
    if (event.altKey) {
      keys.push(CompositeKeys.Alt);
    }
    if (event.metaKey) {
      keys.push(CompositeKeys.Meta);
    }

    return keys;
  }

  function checkIsExactKey(
    event: MouseEvent | KeyboardEvent,
    key: HotKey
  ): boolean {
    if (event instanceof MouseEvent) {
      return false;
    }

    return event.code === key;
  }
}
